import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import Web3 from 'web3';
import getNodeUrl from './rpcRandom';
export var checkWalletOnChain = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(account) {
    var result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all([1, 56, 137, 2020, 43114, 250].map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(chainID) {
                var web3, txCount;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        web3 = new Web3(getNodeUrl(chainID));
                        _context.next = 3;
                        return web3.eth.getTransactionCount(account);

                      case 3:
                        txCount = _context.sent;
                        return _context.abrupt("return", txCount !== 0 ? chainID : null);

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 2:
            result = _context2.sent;
            return _context2.abrupt("return", result.filter(function (chainID) {
              return !!chainID;
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function checkWalletOnChain(_x) {
    return _ref.apply(this, arguments);
  };
}();